import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-p-[20px] md:tw-p-[40px] !tw-pb-[0px] tw-text-sm tw-font-medium" }
const _hoisted_2 = { class: "tw-p-10 modal-assessment" }
const _hoisted_3 = { class: "button-container tw-flex tw-justify-end" }

import CircularProgressPercent from "../common/circularProgressPercent.vue";
import {
  IAssessmentQuestionOverride,
  AssessmentAnswerType,
} from "@/interfaces/assessments/IAssessmentQuestion";
import BaseInput from "../common/form/baseInput.vue";
import { PropType, Ref, reactive, ref } from "vue";
import useVuelidate from "@vuelidate/core";
import {
  getComponentUiText,
  IsNumberBetween0And100Valid,
} from "@/utils/utilities";
import TextArea1 from "../common/textArea1.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import { IAssessmentQuestion } from "@/interfaces/assessments/IAssessmentQuestion";
import { helpers } from "@vuelidate/validators";


export default /*#__PURE__*/_defineComponent({
  __name: 'overrideAssessmentQuestion',
  props: {
  type: {
    type: String,
    required: true,
  },
  value: {
    type: Object as PropType<IAssessmentQuestion>,
    default: () => ({}),
    required: true,
  },
},
  setup(__props) {

const props = __props;

const overrideScoreOptions: Ref<IDropDownData[]> = ref([] as IDropDownData[]);
for (let i = 0; i <= 100; i += 5) {
  overrideScoreOptions.value.push({ id: i, name: i + "%" });
}



const initialForm: IAssessmentQuestionOverride = {
  defaultComplianceScore: props.value.percent,
  compensatingOverrideScore: props.value.compensatingOverrideScore
    ? props.value.compensatingOverrideScore
    : null,
  complianceOverrideScore: props.value.complianceOverrideScore
    ? props.value.complianceOverrideScore
    : null,
  compensatingType: "",
  note: "",
};

const rules = {
  defaultComplianceScore: {},
  compensatingOverrideScore: {
    IsNumberBetween0And100Valid: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-assessments-message-input-compliance-override-score-in-override-score",
        ),
      IsNumberBetween0And100Valid,
    ),
  },
  complianceOverrideScore: {
    IsNumberBetween0And100Valid: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-assessments-message-input-compliance-override-score-in-override-score",
        ),
      IsNumberBetween0And100Valid,
    ),
  },
  compensatingType: {},
  note: {},
};

const formModel = reactive({ ...initialForm });
const vueValidate = useVuelidate(rules, formModel as any);

const onsubmit = async () => {
  await vueValidate.value.$validate();
  if (vueValidate.value.$invalid) return;
};

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_b_row, { class: "tw-flex tw-items-center tw-h-[54px]" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { sm: "5" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
            "app-component-assessments-override-question-default-compliance-score-1",
          )), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { sm: "7" }, {
            default: _withCtx(() => [
              _createVNode(CircularProgressPercent, {
                percent: formModel.defaultComplianceScore
              }, null, 8, ["percent"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", { onKeyupEnter: onsubmit }, [
        (props.type === _unref(AssessmentAnswerType).COMPLIANCE)
          ? (_openBlock(), _createBlock(BaseInput, {
              key: 0,
              id: "complianceOverrideScore",
              modelValue: formModel.complianceOverrideScore,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.complianceOverrideScore) = $event)),
              validation: _unref(vueValidate).complianceOverrideScore,
              label: 
          _unref(getComponentUiText)(
            'app-component-assessments-override-question-compliance-score-1',
          )
        
            }, null, 8, ["modelValue", "validation", "label"]))
          : _createCommentVNode("", true),
        (props.type === _unref(AssessmentAnswerType).COMPENSATING)
          ? (_openBlock(), _createBlock(BaseInput, {
              key: 1,
              id: "compensatingOverrideScore",
              modelValue: formModel.compensatingOverrideScore,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.compensatingOverrideScore) = $event)),
              validation: _unref(vueValidate).compensatingOverrideScore,
              label: 
          _unref(getComponentUiText)(
            'app-component-assessments-override-question-compensating-score-1',
          )
        
            }, null, 8, ["modelValue", "validation", "label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_b_row, { class: "tw-mt-[20px]" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, { sm: "5" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-override-question-note-title-1",
            )), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_b_col, { sm: "7" }, {
              default: _withCtx(() => [
                _createVNode(TextArea1, {
                  id: "note",
                  value: formModel.note,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formModel.note) = $event)),
                  class: "tw-h-[157px]",
                  placeholder: 
              _unref(getComponentUiText)(
                'app-component-assessments-override-question-note-prompt-1',
              )
            ,
                  "no-resize": true,
                  name: "note"
                }, null, 8, ["value", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_b_button, {
          variant: "primary",
          class: "button-verify tw-bg-[#387DFF] tw-py-[11px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
            "app-component-assessment-modal-assessment-save-button-1",
          )), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})